import React from "react";
import st from './Badge.module.scss'
import { ExpensesDetalizationData } from "../../../../../store/reducers/dashboard/expenses/detalization";


interface BadgeProps {
    category: ExpensesDetalizationData,
}

export default ({ category }: BadgeProps) => {
    return <div className={st.title} style={{ backgroundColor: category.badgeBg, borderColor: category.badgeStroke, color: category.badgeFg }}>{category.title}</div>
}